<template>
  <div>
    <b-row>
      <b-col>
        <span class="keyword-tag">Traning Image</span>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col>
        <div class="image-train-box">
          <div class="panel-upload d-flex flex-wrap p-3">
            <div class="panel-bg-file-img mr-1">
              <font-awesome-icon icon="plus" color="#40A9D1" class="icon-add" />
              <input
                type="file"
                v-on:change="onFileChange"
                :required="required"
                :name="name"
                ref="input"
                accept="image/png, image/jpeg"
              />
            </div>

            <div v-for="(image, index) in dataList" :key="index" class="">
              <div
                class="panel-bg-file-image mr-1 mb-1"
                v-bind:style="{
                  backgroundImage: 'url(' + image.imageUrl + ')'
                }"
              >
                <font-awesome-icon
                  class="icon-delete"
                  icon="times-circle"
                  color="#FFFFFF"
                  @click="deleteImage(index)"
                />
              </div>
            </div>

            <ModalAlertError ref="modalAlertError" :text="modalMessage" />
          </div>
        </div>
      </b-col>
    </b-row>
    <div v-if="v && v.$error" class="mt-1 mb-2">
      <span class="text-error" v-if="v.required == false">
        กรุณาเลือกรูปภาพอย่างน้อย 1 รูป
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
export default {
  components: {
    ModalAlertError
  },
  props: {
    dataList: {
      required: false,
      type: Array
    },
    required: {
      required: false,
      type: Boolean
    },
    name: {
      required: false,
      type: String
    },
    urlkey: {
      required: false,
      type: String
    },
    index: {
      required: false,
      type: Number
    },
    optionIndex: {
      required: false,
      type: Number
    },
    v: {
      required: false,
      type: Object
    }
  },
  data() {
    return {
      file: "",
      value: "",
      type: {
        all: ["image/jpeg", "image/png", "application/pdf", ""],
        file: ["image/jpeg", "image/png", "application/pdf"],
        image: ["image/jpeg", "image/png"]
      },
      error: "",
      sortOrder: 0,
      data: this.dataFile && this.dataFile.productImageId ? true : false,
      modalMessage: ""
    };
  },
  computed: mapGetters(["headers"]),
  created: function() {},
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];
      var _validFileExtensions = ["image/jpeg", "image/png"];

      if (e.target.files.length) {
        if (_validFileExtensions.indexOf(file.type) < 0) {
          this.$refs.input.value = "";
          this.modalMessage = `${this.$t("fileNotSupport")}`;
          this.$refs.modalAlertError.show();
        } else if (file.size > 10000000) {
          this.modalMessage = `${this.$t("fileIsTooLarge")}`;
          this.$refs.modalAlertError.show();
        } else {
          this.handleChangeFileImage(file);
        }
      } else {
        this.$refs.input.value = "";
      }
    },
    saveImage: async function(value) {
      this.image = await this.saveImagetoDb(value);
      let body = {
        Id: 0,
        imageUrl: this.image
      };
      this.dataList.push(body);
      this.$emit("handleChangeImageList", this.dataList);
    },
    deleteImage(index) {
      this.dataList.splice(index, 1);
      this.$emit("handleChangeImageList", this.dataList);
    },
    handleChangeFileImage: async function(value) {
      if (value) {
        var reader = new FileReader();
        reader.readAsDataURL(value);
        reader.onload = () => {
          this.value = reader.result;
          this.saveImage(reader.result);
        };
      } else {
        this.value = "";
      }
    },

    saveImagetoDb: async function(img) {
      var imgData = {
        base64: img
      };
      return new Promise((resolve, reject) => {
        this.axios.post(`${this.$baseUrl}/image/save`, imgData).then(data => {
          if (data.result == 1) {
            resolve(data.detail.url);
          } else {
            reject(data);
          }
        });
      });
    },

    changeIndex: function(value) {
      if (this.data) {
        this.$emit("changeIndex", value);
      }
    },
    reloadImages: async function() {
      if (this.data) {
        await this.$callApi(
          "delete",
          `${this.$baseUrl}/api/productimages/delete/${this.dataFile.productImageId}`,
          null,
          this.headers,
          null
        );
      }
      this.$emit("reloadImages", this.index);
    }
  }
};
</script>

<style lang="scss" scoped>
.image-train-box {
  border: 1px solid #bcbcbc;
  height: 200px;
  overflow: auto;
  border-radius: 6px;
}
.keyword-tag {
  color: #404040;
  font-size: 16px;
  margin-bottom: 2px;
  font-weight: bold;
}
.panel-upload {
  position: relative;
  margin-bottom: 15px;
}
.icon-add {
  position: absolute;
  top: 50%;
  left: 50%;
  -moz-transform: translateX(-50%) translateY(-50%);
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  width: 20px;
  height: 20px;
}

.icon-delete {
  position: absolute;
  right: 5px;
  top: 5px;
  color: #707070;
}
.label-file {
  top: 0px;
  position: absolute;
  right: 60px;
  margin-right: 5px;
}
.panel-bg-file-img {
  position: relative;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  /* padding-bottom: 20%; */
  height: 80px;
  border: 2px dashed #40a9d1;
  border-radius: 6px;
  width: 80px;
  cursor: pointer;
}
.panel-bg-file-image {
  position: relative;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  /* padding-bottom: 100%; */
  border: 2px dashed #bebebe;
  border-radius: 6px;
  width: 80px;
  height: 80px;
  cursor: pointer;
}
.icon-camera {
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: #afce38;
  border-radius: 50%;
  padding: 7px;
  cursor: pointer;
}
input[type=file], /* FF, IE7+, chrome (except button) */
input[type=file]::-webkit-file-upload-button {
  /* chromes and blink button */
  cursor: pointer;
  width: 100%;
  height: 100%;
  line-height: 95px;
  position: absolute;
  opacity: 0;
}
.text-error {
  color: #ff0000;
  font-size: 14px;
}
</style>
